import { render, staticRenderFns } from "./shortcutSkeleton.vue?vue&type=template&id=310bf002&scoped=true"
import script from "./shortcutSkeleton.vue?vue&type=script&lang=js"
export * from "./shortcutSkeleton.vue?vue&type=script&lang=js"
import style0 from "./shortcutSkeleton.vue?vue&type=style&index=0&id=310bf002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bf002",
  null
  
)

export default component.exports